import React from "react";
import { Drawer, Table, Radio, message } from "antd";
import Close from "../../../../assets/images/close-x.svg";

const BatchSelectionDrawer = ({
  displayBatchSelection,
  setDisplayBatchSelection,
  batchSetAvailable,
  selectedBatch,
  setSelectedBatch,
  selectedQty,
  setSelectedQty,
  currenciesList,
  posConfig,
  compactTable,
  columns,
  onlineBatches,
  selectProductToCart,
}) => {
  return (
    <Drawer
      headerStyle={{ backgroundColor: "#ffffff" }}
      styles={{ body: { padding: "0.5rem", paddingTop: 0, background: "white" } }}
      style={{ borderRadius: "15px" }}
      title={
        <div
          style={{
            position: "relative",
            width: "100%",
            textAlign: "center",
            fontSize: "1.2em",
            fontWeight: "500",
            color: "#0F0718",
            fontFamily: "Inter",
          }}
        >
          Select Batch

          <img
            src={Close}
            onClick={() => {
              setSelectedBatch(null);
              setSelectedQty(1);
              setDisplayBatchSelection(false);
            }}
            style={{
              position: "absolute",
              right: "0",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              width: "20px",
              height: "20px",
            }}
            alt="Close"
          />
        </div>
      }
      placement="right"
      closable={false}
      onClose={() => setDisplayBatchSelection(false)}
      open={displayBatchSelection}
      width="70vw"
      styles={{ mask: { backgroundColor: "#000000a6" } }}
    >
      {/* TABLE BLOCK */}
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #D1D5DB",
          borderRadius: "8px",
          padding: "0",
          overflow: "hidden",
          margin: "10px 20px 20px 20px",
        }}
      >
        <Table
          className="clean-batch-table"
          dataSource={posConfig?.disableOfflineBilling === "Y" ? onlineBatches : batchSetAvailable}
          pagination={false}
          rowKey={(row) => row?.mBatchId}
          size="small"
          scroll={{ y: 300 }}
          bordered={false}
          components={compactTable}
          columns={columns}
          rowClassName={(record) => (selectedBatch?.mBatchId === record?.mBatchId ? "selected-row" : "")}
          onRow={(record) => ({
            onClick: () => setSelectedBatch(record),
          })}
        />
      </div>

      {/* SELECTED INFO PANEL */}
      <div style={{ padding: "0 20px" }}>
        {selectedBatch && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: "12px",
              marginTop: "20px",
            }}
          >
            {/* BOX: Selected + Qty */}
            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: "16px",
                padding: "20px",
                backgroundColor: "#F3F4F9",
                borderRadius: "14px",
                border: "1px solid #D1D5DB",
              }}
            >
              {/* TEXT */}
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "0.9em", fontWeight: 500 }}>Selected Batch: {selectedBatch?.batchno}</div>
                <div style={{ marginTop: "8px", fontSize: "0.9em", color: "#6B7280" }}></div>
                <div style={{ fontSize: "0.9em", fontWeight: 500 }}>
                  {currenciesList[0].symbolRightSide === "N" ? `${currenciesList[0].currSymbol} ` : ""}
                  {Number(selectedBatch?.salePrice ?? 0).toLocaleString()}
                  {currenciesList[0].symbolRightSide === "Y" ? ` ${currenciesList[0].currSymbol} ` : ""}
                </div>
              </div>

              {/* QTY INPUT INSIDE BOX */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #D1D5DB",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  height: "40px",
                  width: "90px",
                  padding: "0 8px",
                  justifyContent: "space-between",
                }}
              >
                <input
                  inputMode="numeric"
                  style={{ border: "none", outline: "none", width: "40px", textAlign: "center" }}
                  value={selectedQty}
                  onChange={(e) => {
                    const num = e.target.value.replace(/\D/g, "");
                    setSelectedQty(num === "" ? "" : Number(num));
                  }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ cursor: "pointer", fontSize: "10px" }} onClick={() => setSelectedQty((n) => Number(n || 0) + 1)}>
                    ▲
                  </div>
                  <div style={{ cursor: "pointer", fontSize: "10px" }} onClick={() => setSelectedQty((n) => Math.max(1, Number(n) - 1))}>
                    ▼
                  </div>
                </div>
              </div>
            </div>

            {/* ADD TO CART BUTTON OUTSIDE BOX */}
            <button
              onClick={() => {
                const stock = Number(selectedBatch?.stock ?? 0);
                const qty = Number(selectedQty ?? 0);

                if (stock <= 0) {
                  message.warning("This batch is out of stock and cannot be added.");
                  return;
                }

                if (qty > stock) {
                  message.warning("Selected quantity exceeds available stock.");
                  return;
                }
                // PASSES VALIDATIONS
                selectProductToCart(selectedBatch, selectedQty);
                setSelectedBatch(null);
                setSelectedQty(1);
                setDisplayBatchSelection(false);
              }}
              style={{
                backgroundColor: "#F3F4F9",
                color: "#0F0718",
                border: "1px solid #d9d9d9",
                padding: "12px 22px",
                borderRadius: "8px",
                fontSize: "0.9em",
                fontWeight: "500",
                height: "45px",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              Add to Cart
            </button>
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default BatchSelectionDrawer;
